import { type Action, createHook, createStore } from 'react-sweet-state';

export type State = {
	issueIdToReparent: string | null;
};

const actions = {
	openReparentModal:
		(issueIdToReparent: string): Action<State> =>
		({ setState }) => {
			setState({ issueIdToReparent });
		},
	closeReparentModal:
		(): Action<State> =>
		({ setState }) => {
			setState({ issueIdToReparent: null });
		},
};

export type Actions = typeof actions;

const ReparentModalStore = createStore<State, Actions>({
	initialState: {
		issueIdToReparent: null,
	},
	actions,
	name: 'JWMReparentModal',
});

export const useReparentModalStore = createHook(ReparentModalStore);

export const getShouldShowReparentModal = (state: State) => state.issueIdToReparent != null;

export const useShouldShowReparentModal = createHook(ReparentModalStore, {
	selector: getShouldShowReparentModal,
});
